import { Box, Card, Divider, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

const WideList = ({
  header = null,
  body = null,
  footer = null,
  boxStyle = {},
  headerDivider = header !== null,
  footerDivider = footer !== null,
  overflowX = null,
}) => {
  return (
    <Card
      sx={{
        mt: 2,
        border: '1px solid',
        borderColor: '#99999975',
        borderRadius: '25px',
        maxWidth: '100%',
        overflowX: overflowX ?? 'scroll',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollbarWidth: 'none',
      }}
    >
      <Box sx={boxStyle}>
        <Grid container display="flex" direction="column">
          <Grid item xs={12}>
            {header}
          </Grid>
          <Grid item xs={12}>
            {headerDivider && <Divider />}
          </Grid>
          <Grid item xs={12}>
            {body}
          </Grid>
          <Grid item xs={12}>
            {footerDivider && <Divider />}
          </Grid>
          <Grid item xs={12}>
            {footer}
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
}

WideList.propTypes = {
  body: PropTypes.any,
  footer: PropTypes.any,
  footerDivider: PropTypes.bool,
  header: PropTypes.any,
  headerDivider: PropTypes.bool,
  boxStyle: PropTypes.object,
  overflowX: PropTypes.string,
}

export default WideList
